import React, { useEffect, useState, ReactText } from 'react';
import { Trans } from '@lingui/react/macro';
import { getPricingFields } from '@/services/projects';
import { PricingField } from '@/types';
import Banner from '@/components/Banner';
import { Select } from '@ygtechnologies/bygr-frontend-component-library';

export interface LinkToUnitPriceModifierProps {
    selectedProjectId: number | null;
    onChange: (id: number | null) => void;
    selectedPriceFieldId: number | null;
}

export const LinkToUnitPriceModifier: React.FC<LinkToUnitPriceModifierProps> = ({
    selectedProjectId,
    onChange,
    selectedPriceFieldId,
}) => {
    const [priceModifiers, setPriceModifiers] = useState<PricingField[]>([]);
    useEffect(() => {
        async function load() {
            if (selectedProjectId) {
                setPriceModifiers(await getPricingFields(selectedProjectId));
            } else {
                setPriceModifiers([]);
            }
        }

        load();
    }, [selectedProjectId]);

    // useEffect(() => {
    //     if (priceModifiers && priceModifiers.length >= 1) {
    //         onChange(priceModifiers[0].id);
    //     }
    // }, [priceModifiers]);
    const options: { value: ReactText; label: any }[] = priceModifiers.map((pf) => ({
        value: pf.id,
        label: `${pf.name} ${pf.description ? ' - ' + pf.description : ''}`,
    }));
    options.unshift({ value: '', label: <Trans>Single item</Trans> });

    return (
        <div>
            <div>
                <Trans>Select a pricing variable</Trans>
            </div>
            <Banner type="info">
                <Trans>
                    <strong>Please note </strong> the price of each product in this option will be multiplied by this
                    variable. This number may be different for each unit. This is usually used for products like flooring and
                    tiles. Use "single item" in order to not multiply the price.
                </Trans>
            </Banner>

            <div className="form-group">
                <Select
                    defaultValue={options[0]}
                    value={options.find((o) => o.value === selectedPriceFieldId)}
                    onChange={(nw: any) => onChange(nw.value)}
                    options={options}
                />
            </div>
        </div>
    );
};
